import React from "react";
import { PageLink, KontentRichText, ComponentProps } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { HeroEquals } from "../../elements/Equals/equals";
import {
  SolidHeroProps,
  SolidHeroWrapper,
} from "../../elements/HeroWrapper/Solid";
import * as styles from "./SimpleHero.module.css";
import { SimpleHeroContent } from "./SimpleHeroContent";

interface Props extends ComponentProps, SolidHeroProps {
  title: string;
  text?: KontentRichText;
  sidekick?: KontentRichText;
  cta?: PageLink;
}

export const SimpleHero: React.FC<Props> = ({
  title,
  text,
  sidekick,
  cta,
  style,
  height,
  ...props
}) => {
  return (
    <SectionWrapper {...props}>
      <SolidHeroWrapper style={style} height={height}>
        <SimpleHeroContent
          title={title}
          text={text}
          cta={cta}
          style={style}
        ></SimpleHeroContent>
        <HeroEquals className={styles.equals} id={`hero${props.id}`} />
      </SolidHeroWrapper>
    </SectionWrapper>
  );
};
